import React, { useMemo } from 'react'
import { Link, useHistory } from 'react-router-dom'
import FadeIn from '../../../molecules/Transitions/FadeIn'
import OperationalTable from '../../../organisms/OperationalTable'
import { ADMIN_ROUTES } from '../../../../constants'
import { useTargetModels } from '../../../../api/rebalancer'

const cellTemplates = {
  link: (accessor) => ({ row }) => (
    <Link
      onClick={(event) => event.stopPropagation()}
      to={`${ADMIN_ROUTES.TARGET_MODEL_DETAILS}/${row.original.targetModelId}`}
    >
      {accessor(row.original) || 'Link'}
    </Link>
  )
}

export const defaultColumnConfig = {
  columns: [
    { Header: 'Id', accessor: 'targetModelId', type: 'number', Cell: cellTemplates.link(row => row.targetModelId) },
    { Header: 'Name', accessor: 'name', type: 'string', Cell: cellTemplates.link(row => row.name) },
    { Header: 'Description', accessor: 'description', type: 'string' }
  ],
  defaultSort: [{ id: 'targetModelId', desc: false }]
}

function TargetModelsListTab () {
  const query = useMemo(() => {
    return { take: 200 }
  }, [])
  const history = useHistory()
  const { data, isLoading } = useTargetModels(query)

  return (
    <FadeIn style={{ marginTop: '20px' }}>
      <OperationalTable
        variant='v2'
        mode='client'
        itemName='Target Models'
        data={data || []}
        loading={isLoading}
        total={data?.length}
        columns={defaultColumnConfig.columns}
        defaultSort={defaultColumnConfig.defaultSort}
        onRowClick={(row) => history.push(`${ADMIN_ROUTES.TARGET_MODEL_DETAILS}/${row.original.targetModelId}`)}
      />
    </FadeIn>
  )
}

TargetModelsListTab.propTypes = {
}

TargetModelsListTab.defaultProps = {
}

export default TargetModelsListTab
